// export { IppicaEmptyState } from './IppicaEmpty';

import dynamic from 'next/dynamic';

export type { IppicaEmptyProps as IppicaEmptyType } from './IppicaEmpty';
export const IppicaEmpty = dynamic(
  () => import('features/ippica/components/ippicaEmpty/IppicaEmpty').then((mod) => mod.IppicaEmpty),
  { ssr: false }
);
